import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=ef2ae8f8&scoped=true&"
import script from "./DynamicPage.vue?vue&type=script&lang=js&"
export * from "./DynamicPage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPage.vue?vue&type=style&index=0&id=ef2ae8f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2ae8f8",
  null
  
)

export default component.exports